import { render, staticRenderFns } from "./miniEquity.vue?vue&type=template&id=84bc7d60&"
import script from "./miniEquity.vue?vue&type=script&lang=js&"
export * from "./miniEquity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports